import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Col, Row, Collapse, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { updateUi, clearLastTicketImportLogs, } from '../../redux';
import { ScreeningsImporter, TicketsImporter, TicketsRawImporter } from '..';
import moment from 'moment';
import { Log, Setting } from '../../models';
import { Utils } from '../../services';
import i18n from '../../locales/i18n';
import _ from 'lodash';
import classnames from 'classnames';

import './SynchronisationPanel.css';
import ModalComponent from '../ModalComponent';

const SynchronisationPanel = () => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const [activeTab, setActiveTab]               = useState('screenings');
    const [activeTicketsTab, setActiveTicketsTab] = useState('csv');

    const { showSynchronisationPanel } = useSelector(state => state.ui);
    const { setting }                  = useSelector(state => state.settings);

    const screeningsImportConfig = React.useMemo(() => setting ? (new Setting(setting)).getScreeningsImportConfiguration() : null, [setting]);
    const ticketsImportConfig    = React.useMemo(() => setting ? (new Setting(setting)).getTicketsImportConfiguration() : null, [setting]);

    const toggle = tab => {
        if (activeTab !== tab)
            setActiveTab(tab);
    }

    const toggleTickets = tab => {
        if (activeTicketsTab !== tab) {
            dispatch(clearLastTicketImportLogs());
            setActiveTicketsTab(tab);
        }
    }

    const close = () => {
        dispatch(updateUi({ showSynchronisationPanel: false }));
    };

    return (
        <div className={`SynchronisationPanel ${showSynchronisationPanel ? 'expanded d-block' : 'reduced'}`}>
            <Button color="danger" size="sm" className='float-right' onClick={close}>
                <i className='fa fa-times'></i>
            </Button>
            <h4 className='border-bottom mt-1'>
                <i className='fa fa-download'></i>&nbsp;{t('events.sync_and_import')}
            </h4>
            <br />
            <Nav tabs>
                {screeningsImportConfig && (
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === 'screenings' })} onClick={() => { toggle('screenings'); }}>
                            {t(`events.sync_screenings_tab_${screeningsImportConfig.source}`)}
                        </NavLink>
                    </NavItem>
                )}
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === 'tickets' })} onClick={() => { toggle('tickets'); }}>
                        {t('tickets.import.tab_title')}
                    </NavLink>
                </NavItem>
            </Nav>
            <br />
            <TabContent activeTab={activeTab}>
                <ScreeningsImporter visible={ activeTab === 'screenings' }/>

                {activeTab === 'tickets' && (
                <>
                    {ticketsImportConfig ? (
                    <>
                        <Nav tabs>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTicketsTab === 'csv' })} onClick={() => { toggleTickets('csv'); }}>
                                    {t('tickets.import.tab_csv')}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTicketsTab === 'integration' })} onClick={() => { toggleTickets('integration'); }}>
                                    {t(`tickets.import.tab_${ticketsImportConfig.source}`)}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <br />
                        <TabContent activeTab={activeTicketsTab}>
                            <TicketsRawImporter visible={ activeTicketsTab === 'csv' }/>
                            <TicketsImporter visible={ activeTicketsTab === 'integration' }/>
                        </TabContent>
                    </>
                    ) : (
                        <TicketsRawImporter visible={ true }/>
                    )}
                </>
                )}
            </TabContent>
        </div>
    );
}

export default SynchronisationPanel;
